<template>
  <v-row>
    <v-col>
      すでに会員の方は
      <a :href="signInUrl">サインイン</a>
      してください。
    </v-col>
  </v-row>
</template>

<script>
import { getQueryParamsStringFromJson } from '@/views/SignIn.vue'

export default {
  computed: {
    signInUrl() {
      return `/sign-in${getQueryParamsStringFromJson({ plan: this.$route.query.plan })}`
    }
  }
}
</script>
